<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'LayoutCertification',
  data() {
    return {
      isTheme: true
    };
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
// .header_inner{
//   background: rgba(22, 26, 37, 0.95) !important;
// }
.sidebar-container {
  background: #fff;
  flex-grow: 0;
}
.main-container {
  flex-grow: 1;
}
.app-wrappers {
  background: #fff;
  min-height: calc(100vh - 80px);
}
.login_wrap{
  margin:0 !important;
}
</style>
<style rel="stylesheet/scss" lang="scss">
.container {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: calc(100vh - 194px);
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/LayoutCertification.vue